export enum AddMembershipPaymentFormFields {
  IsPaymentRequired = 'isPaymentRequired',
}
